import { defineStore } from 'pinia'

const defaultState = {
  collection_page_id: null,
  page_url: null,
  title: null,
  editorial_text: null,
  meta_title: null,
  meta_description: null,
  robots: null,
  conditions: null,
  show_in_navigation: false,
  navigation_sort_order: null,
  desktop_asset_id: null,
  tablet_asset_id: null,
  mobile_asset_id: null,
  hero_product_id: null,
  hero_campaign_id: null,
  hero_catch_phrase: null
}

export const useCollectionPageStore = defineStore('collectionPage', {
  state: () => ({
    entity: { ...defaultState },
    // Admin-only: { url, reasons[] } when customers would be redirected from this
    // page; used to show the admin warning banner. Null for customers.
    redirectPreview: null
  }),
  getters: {
    page: ({ entity }) => entity
  },
  actions: {
    setFromProductsSearch(collectionPage, redirectPreview = null) {
      this.entity = { ...defaultState, ...collectionPage }
      this.redirectPreview = redirectPreview
    }
  }
})
